const gtmChangePasswordSuccess = () => {
    dataLayer.push({
        event: 'forgot_password',
        step: 'reset_password_success',
        _clear: true,
    })
}

export default gtmChangePasswordSuccess
